<template>
  <div>
    <Historys :item="item" :fields="fields" :childrenFields="childrenFields"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Historys from "@/projects/views/E-Performances/Management/Agency/components/Historys";
export default {
  name: "Affiliations",
  components: {Historys},
  data: function () {
    return {
      item:[],
      fields :[
        {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
        {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
        {key:"title", label:"Name"},
        {key:"total", label: "Total", _style: 'width:30px; text-align: center'},
        {key:"action", label: "#", _style: 'width:30px; text-align: center'}
      ],
      childrenFields :[
        {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
        {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
        {key:"title", label:"Name"},
        // {key:"position", label:"Position"},
        // {key:"dateTime", label:"Start Date"},
        // {key:"experiences", label:"Experience", _style: 'width:220px; text-align: center'},
        {key:"action", label: "#", _style: 'width:30px; text-align: center'}


      ]
    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      // this.$store.dispatch("affiliation/config",{})
      var body = {};
      body.group = true;
      this.$store.dispatch("agency/config",body)
    },

    onLoad() {

    },

    getLocaleValue(items, lang, fallback = "-") {
      if (!Array.isArray(items) || items.length === 0) {
        return fallback;
      }

      const match = items.find((entry) => entry && entry.key === lang) || items[0];
      return match && match.value ? match.value : fallback;
    },

    getLocalizedValue(items, lang, fallback = "-") {
      return this.getLocaleValue(items, lang, fallback);
    },

    getAccountName(account, lang) {
      const userinfo = account && account.userinfo ? account.userinfo : {};
      const name = [
        this.getLocaleValue(userinfo.prefix, lang, ""),
        this.getLocaleValue(userinfo.firstName, lang, ""),
        this.getLocaleValue(userinfo.lastName, lang, "")
      ].filter(Boolean).join(" ").trim();

      return name || "-";
    },

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      agency: 'agency/item',
    })
  },

  watch: {

    agency: function (value) {
      this.item = [];
      var lang = this.$store.getters['setting/lang']
      const items = Array.isArray(value) ? value.map((item) => {
        const normalizedItem = Object.assign({}, item);
        normalizedItem.title = this.getLocaleValue(item && item.title, lang, "-");

        const children = item && Array.isArray(item.item) ? item.item.map((h) => {
          const child = Object.assign({}, h);
          const account = child.accounts || {};

          child.code = account.code || "-";
          child.title = this.getAccountName(account, lang);
          // h.dateTime = h.experience.filter(objs => {
          //   return (objs.type == "000000000000000000000000")
          // })[0].startDate
          //
          // const startDate = moment(h.dateTime);
          // const endDate = moment();
          // const yearsDiff = endDate.diff(startDate, 'years');
          // const monthsDiff = endDate.diff(startDate, 'months') % 12;
          //
          // try {
          //
          //   h.position = h.fields[h.fields.length -1].personnelType.title.filter(title => {
          //     if (title.key == lang) {
          //       return title
          //     }
          //   })[0].value
          // }catch (e) {
          //   h.position = ""
          // }
          //
          // h.experiences = ` ${yearsDiff} ปี ${monthsDiff} เดือน`


          return child;
        }) : [];

        normalizedItem.item = children;
        normalizedItem.total = children.length;
        return normalizedItem;
      }) : [];

      const profile = this.$store.getters["personal/profile"] || {};
      const profileAgencyId = ((profile.agency || {})._id || "").toString();

      if(profile.role != 1 && profileAgencyId){
        this.item = items.filter((objs) => objs && objs._id && objs._id.toString() == profileAgencyId);
      }else{
        this.item = items
      }
    },

  }
}
</script>

<style scoped>

</style>
